import React from "react";
import RangeSlider from "./RangeSlider";
import CURRENCY_META from "../components/currencyMeta";

export default function SalaryRange({
  salaryRange,
  setSalaryRange,
  NoPrefSalary,
  setNoPrefSalary,
  salaryCurrency,
}) {
  const isINR = salaryCurrency === "INR";
  const currency = CURRENCY_META[salaryCurrency] || {
    symbol: salaryCurrency,
    name: salaryCurrency,
  };
  return (
    <div>
      {/* <RangeSlider
        label="Salary Range *"
        unit="Lpa"
        min={3}
        max={100}
        step={0.1}
        values={salaryRange}
        setValues={setSalaryRange}
        leftLabel=""
        rightLabel=""
        colorClass="primary"
        noPref={NoPrefSalary}
        setNoPref={setNoPrefSalary}
      /> */}
      <RangeSlider
        label="Salary Range *"
        unit={isINR ? "LPA" : "K"}
        symbol={currency.symbol}
        min={0}
        max={isINR ? 100 : 10000}
        step={isINR ? 0.1 : 1}
        values={
          isINR ? [salaryRange[0] / 100, salaryRange[1] / 100] : salaryRange
        }
        setValues={(values) =>
          setSalaryRange(
            isINR
              ? [Math.round(values[0] * 100), Math.round(values[1] * 100)] // store in K
              : values,
          )
        }
        leftLabel={`${currency.symbol} ${isINR ? "0 LPA" : "0 K"}`}
        rightLabel={`${currency.symbol} ${isINR ? "100 LPA" : "10000 K"}`}
        colorClass="primary"
        noPref={NoPrefSalary}
        setNoPref={setNoPrefSalary}
      />
    </div>
  );
}
